<template>
  <div class="layout">
    <TheSidebar class="sidebar-wrapper" />
    <div class="main-container" ref="contentWrapper">
      <!-- form-card: start -->
      <BaseCirclesBackground for="layout" />
      <TheNavbar />

      <transition name="fade-transform" mode="out-in">
        <router-view />
      </transition>
    </div>

    <TheModalsContainer />

    <cookies-banner
      class="cookie-banner"
      @close="handleCookieBannerClose"
      position="bottom"
      v-if="cookiesBanner.open"
    >
      <div class="cookie-banner__inner-wrapper">
        <div class="cookie-banner__message">
          <h4 class="lvl4-heading">Nous utilisons les cookies</h4>
          <p>
            Nous utilisons les cookies afin de fournir les services et
            fonctionnalités proposés sur notre site et afin d’améliorer
            l’expérience de nos utilisateurs. Les cookies sont des données qui
            sont téléchargés ou stockés sur votre ordinateur ou sur tout autre
            appareil. En cliquant sur ”J’accepte”, vous acceptez l’utilisation
            des cookies. Vous pourrez toujours les désactiver ultérieurement. Si
            vous supprimez ou désactivez nos cookies, vous pourriez rencontrer
            des interruptions ou des problèmes d’accès au site.
          </p>
        </div>
        <div class="cookie-banner__actions">
          <base-button @click.native="handleAcceptCookies"
            >J'ACCEPTE</base-button
          >
          <base-button @click.native="handleRefuseCookies" type="hollowed"
            >JE REFUSE</base-button
          >
        </div>
      </div>
    </cookies-banner>
  </div>
</template>

<script>
import TheSidebar from "./components/TheSidebar"
import TheNavbar from "./components/TheNavbar"
import TheModalsContainer from "./components/TheModalsContainer"
import { mapGetters } from "vuex"
export default {
  components: {
    TheSidebar,
    TheNavbar,
    TheModalsContainer,
    // BANNERS
    "cookies-banner": () => import("@/components/Banner.vue")
  },
  computed: {
    ...mapGetters(["cookiesBanner", "scroller"])
  },
  methods: {
    scrollTop() {
      if (!this.scroller) return
      this.scroller.scroll({ x: 0, y: 0 }, 800)
    },
    handleCookieBannerClose() {
      this.$store.dispatch("closeCookiesBanner")
    },
    handleRefuseCookies() {
      this.$store.dispatch("removeCookies")
    },
    handleAcceptCookies() {
      this.$store.dispatch("acceptCookies")
    }
  },
  watch: {
    // call again the method if the route changes
    $route: "scrollTop"
  },
  mounted() {
    const scroller = OverlayScrollbars(this.$refs.contentWrapper, {
      overflowBehavior: {
        x: "hidden"
      }
    })
    this.$store.commit("SET_SCROLLER", scroller)

    this.$store.dispatch("openValidationBanner")
    this.$store.dispatch("openCookiesBanner")
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "@/styles/variables.scss";
.layout {
  display: flex;
  flex-flow: row nowrap;
  .sidebar-wrapper {
    width: 100%;
    max-width: $sidebar-width;
    height: 100vh;
  }
  .main-container {
    min-height: 100vh;
    width: 100%;
    flex-grow: 1;
  }
  .cookie-banner {
    padding-top: 50px;
    &__inner-wrapper {
      display: flex;
      flex-flow: row nowrap;
    }
    &__message {
      .lvl4-heading {
        margin-bottom: 10px;
        color: $color-accent;
        color: var(--color-accent, $color-accent);
      }
    }
    &__actions {
      margin-top: 15px;
      margin-left: 20px;
      flex-basis: 277px;
      flex-grow: 0;
      flex-shrink: 0;
      .button:first-child {
        margin-bottom: 10px;
      }
    }
  }
}
</style>
